import styled from "styled-components";
import { Color, Space, Typography } from "../../../settings";

export const Wrapper = styled.header`
  margin: ${Space.xxxLarge.rem} 0;
`;

export const Heading = styled.h1`
  font-size: ${Typography.large.rem};
  margin: 0;
`;

export const Summary = styled.p`
  font-size: ${Typography.large.rem};
  margin: 0;
  margin-top: ${Space.default.rem};
`;

export const Date = styled.p`
  margin-bottom: ${Space.small.rem};
  font-size: ${Typography.default.rem};
`;
